//   ####  ##      ##    ###    #####
//  ##     ##      ##   ## ##   ##  ##
//   ###   ##  ##  ##  ##   ##  #####
//     ##  ##  ##  ##  #######  ##
//  ####    ###  ###   ##   ##  ##
/*
単一のDOMをPCとSPで違うところに移動させる（inputなど重複できない要素に利用）
/*
<div class="pc js-deviceSwap--hoge-pc">
    <div class="js-deviceSwap" data-swap-target="hoge">
    </div>
</div>
<div class="sp js-deviceSwap--hoge-sp"></div>
*/
let deviceSwapLast = ''
function deviceSwap() {
  const itemList = document.querySelectorAll('.js-deviceSwap')
  if (!itemList[0]) {
    return
  }
  if (window.matchMedia('(min-width:769px)').matches) {
    //PC
    if (deviceSwapLast === 'pc') {
      // 前回実行と同じ領域判定なら中止
      return
    }

    deviceSwapLast = 'pc'
  } else {
    //SP
    if (deviceSwapLast === 'sp') {
      // 前回実行と同じ領域判定なら中止
      return
    }
    deviceSwapLast = 'sp'
  }

  for (const item of itemList) {
    const targetName = item.dataset.swapTarget + '-' + deviceSwapLast
    const targetFrame = document.querySelector('.js-deviceSwap--' + targetName)

    targetFrame.appendChild(item)
  }
}

deviceSwap()

window.addEventListener('resize', function (e) {
  deviceSwap()
})
